var paragraph_default = {
  "fontElementMap": "kxqaV",
  "elementSpacing": "h-SF9",
  "text": "CXcsI h-SF9",
  "child": "wCrjQ"
};
export {
  paragraph_default as default
};
//# sourceMappingURL=paragraph-scss.js.map
